module.exports = __webpack_public_path__ + "static/flags/AL-fd591da0574d519a3413fc0de9358b74.gif";